export default __webpack_public_path__ + "static/heroDustBot-76dcf55696045e06dd6feaa948271c56.png";